import { lazy } from 'react'

export const lazyPage = (load) => lazy(load)
